// 下载链接
export const DOWNLOAD_URL = 'https://s.xoyo.com/wuxianpc';

// 官方网站
export const OFFICIAL_URL = '//js4.seasungames.cn/';
